// Vendored copies of the production site templates (from
// functions/src/sites/templates/) used so the /demo buyer preview renders the
// EXACT template real users get when generating a site — not a simplified
// demo approximation.
//
// Only the pure, browser-safe files are copied: mono-type.ts plus its
// dependency-free helpers (helpers.ts, sanitize.ts, types.ts). They have no
// firebase/node imports. If the production "Mono Type" template changes,
// re-copy these four files.

import { monoType } from './mono-type';
import type { TemplateData } from './types';

export type { TemplateData } from './types';

// Render the real "Mono Type" template with a generous feature set so the
// demo shows a full-looking site (reviews, gallery, hours, services).
export function renderMonoTypeSite(data: TemplateData): string {
  const features = new Set<string>([
    'contact-form',
    'phone-display',
    'about-section',
    'services-list',
    'testimonials',
    'google-reviews',
    'photo-gallery',
    'business-hours',
  ]);
  return monoType.render(data, features);
}
